module.exports = __webpack_public_path__ + "static/media/couriermaping.6bdd0167.png";